<div class="modal-header">
  <h4 class="modal-title">Address Lookup</h4>
</div>
<div class="modal-body" *ngIf="viewModel$ | async as vm">
  <form [formGroup]="formGroup">
    <input
      #address
      type="text"
      type="text"
      class="form-control"
      size="50"
      formControlName="addressLookup"
    />
    <table class="table table-hover">
      <thead>
        <tr>
          <th></th>
          <th>Address1</th>
          <th>Address2</th>
          <th>Suburb</th>
          <th>
            {{
              this.formGroup.controls.country.value === "New Zealand"
                ? "City"
                : "State"
            }}
          </th>
          <th>Postcode</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="!vm.addresses">
          <tr>
            <td colspan="6">
              <div class="d-flex align-items-center">
                <span>Searching...</span>
                <div
                  class="spinner-border ml-auto"
                  role="status"
                  aria-hidden="true"
                ></div>
              </div>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="vm.addresses && vm.addresses.length === 0">
          <tr>
            <td colspan="6">No matching addresses found</td>
          </tr>
        </ng-container>
        <ng-container *ngIf="vm.addresses && vm.addresses.length > 0">
          <tr
            *ngFor="let a of vm.addresses"
            class="cursor-pointer"
            [ngClass]="{ 'table-primary': a === vm.address }"
            (click)="setAddress(a)"
          >
            <td>
              <div class="custom-control custom-radio">
                <input
                  type="radio"
                  class="custom-control-input"
                  formControlName="address"
                  [value]="a"
                />
                <label class="custom-control-label"></label>
              </div>
            </td>
            <td>{{ a.address1 }}</td>
            <td>{{ a.address2 }}</td>
            <td>{{ a.suburb }}</td>
            <td>{{ a.state }}</td>
            <td>{{ a.postcode }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </form>
</div>
<div class="modal-footer">
  <button type="submit" class="btn btn-primary" (click)="select()">
    Select
  </button>
  <button type="button" class="btn btn-secondary" (click)="cancel()">
    Cancel
  </button>
</div>
